import type { Phone } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetPhones } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { usePhonesSWRKey } from "./usePhonesSWRKey"

export function usePhones(): SWRResponse<Array<Phone>> {
  const phonesSWRKey = usePhonesSWRKey()
  const getPhones = useGetPhones()

  const getPhonesData = useMemo(
    () => !getPhones ? null : (async () => {
      const response = await getPhones({ params: {} })
      return response
    }),
    [getPhones],
  )

  return useSWR<Array<Phone>>(
    phonesSWRKey,
    getPhonesData,
  )
}
